import { atomWithStorage } from 'jotai/utils';

const STORAGE_KEY = 'notification';

const 알림_아톰_초기값: Record<string, string> = {};

export const notificationPersistAtom = atomWithStorage(STORAGE_KEY, 알림_아톰_초기값);
